import styled from 'styled-components';
import { Form as Unform } from '@unform/web';

export const Container = styled.div`
  background: var(--background-color);
  width: 100%;
`;

export const Title = styled.h1`
  color: var(--color);
  font-family: 'GothamBold', Arial, Helvetica, sans-serif;
  font-size: 3.2rem;
`;

export const Form = styled(Unform)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  justify-items: start;
  & > div {
    align-self: start;
  }

  @media (max-width: 600px) {
    display: flex;
    flex-direction: column;
  }
`;
